import {
  AlertConfirmationTypes,
  MinorAilmentStep,
} from "../../../helpers/constant";
import Button from "../../common/Button";
import UrinaryTractData from "../clinical-services/service-steps/other/urinary-tract-data";

export const ClinicalServiceTypes = {
  MedicationReview: "AnnualMedicationReview",
  AllergicRhinitis: "allergicRhinitis",
};

// Centralized Drug Therapy Problem options for interventions
export const DPTOptions = [
  {
    value: "therapeuticDuplication",
    label: "Therapeutic Duplication; drug may not be necessary",
  },
  { value: "requiresDrug", label: "Requires Drug; needs additional therapy" },
  {
    value: "subOptimalResponse",
    label: "Sub-Optimal Response; drug not working well",
  },
  { value: "dosagetooLow", label: "Dosage too Low; needs higher dose" },
  {
    value: "adverseDrugReaction",
    label: "Adverse Drug Reaction; related to allergy or interactions",
  },
  {
    value: "dangerouslyHighDose",
    label: "Dangerously High Dose; taking too much drug",
  },
  {
    value: "nonCompliance",
    label: "Non-Compliance; refusing to take or not taking properly",
  },
  {
    value: "prescriptionChanged",
    label: "Prescription has been confirmed false or altered",
  },
];

export const minorAilments = [
  {
    title: "Acne",
    code: "acne",
    content: (
      <p>
        Acne is a common skin condition that happens when hair follicles under
        the skin become clogged.
      </p>
    ),
    maxClaims: 4,
    upcomingFollowUp: (
      <div className="mt-2 mb-2 p-3 mx-2.5 flex bg-blue-100 border-[1px] border-blue-400 rounded-[4px]">
        <div className="w-12 min-w-[48px] h-12">
          <img
            src="/icons/info-circle.svg"
            alt="info-circle"
            className="w-12 h-12"
          />
        </div>
        <div className="flex flex-col ml-5 mt-3 ">
          <p className="text-body-md font-semibold text-gray-800">
            Upcoming: Follow Up Due January 5th.
          </p>
          <p className="text-body-md mt-2 text-gray-800 font-normal">
            Minor Ailment service was completed on September 30, 2023. Complete
            a follow up prior to initiating a new minor ailment service.
          </p>
        </div>
        <Button
          type={"primary-outline"}
          text="Start Follow Up"
          className="ml-[50px] !max-w-[200px] w-full h-max my-auto"
        />
      </div>
    ),
    isTooltip: false,
    disable: true,

  },
  {
    title: "Allergic Rhinitis",
    code: "allergicRhinitis",
    content: (
      <p>
        Allergic Rhinitis is an inflammation (redness and swelling) of the
        inside of the nose.
        <br />
        It's caused by an allergen such as pollen, dust, mould and pets.
      </p>
    ),
    maxClaims: 4,
    isTooltip: true,
    allowTreatment: true,
    allowPrevention: true,
    disable: false,
  },
  {
    title: "Oral Aphthous Ulcer (Canker Sore)",
    code: "oralAphthousUlcerCankerSore",
    content: (
      <p>
        Cankers sores are painful, recurrent lesions which occur on the oral
        mucosa, which is the skin inside of the mouth, cheeks and lips.
      </p>
    ),
    maxClaims: 4,
    isTooltip: false,
    disable: true,
  },
  {
    title: "Oral Candidiasis (Thrush)",
    code: "oralCandidiasisThrush",
    content: (
      <p>
        Oral thrush is a fungal infection of the oral mucosa, which is the skin
        inside of the mouth, cheeks and lips. Usually caused by Candida species.
      </p>
    ),
    maxClaims: 4,
    isTooltip: false,
    disable: true,
  },
  {
    title: "Conjunctivitis",
    code: "conjunctivitis",
    content: (
      <>
        <p>
          Conjunctivitis is any inflammation of the membrane that lines the
          inside of the eyelids and covers the white area of the eye (also
          called sclera). It is the most common cause of “Pink Eye”.
        </p>
        <p>It can be bacterial, viral or allergic conjunctivitis.</p>
      </>
    ),
    maxClaims: 3,
    isTooltip: false,
    disable: true,
  },
  {
    title: "Dermatitis (Atopic, eczema, allergic and contact)",
    code: "dermatitisAtopicEczemaAllergicAndContact",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Diaper dermatitis",
    code: "diaperDermatitis",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Dysmenorrhea",
    code: "dysmenorrhea",
    content: (
      <>
        <p>
          Dysmenorrhea is <strong>painful menstruation (a period)</strong>{" "}
          occurring shortly before and/or during the beginning of menstruation.
          It is normal vaginal bleeding that occurs as part of a woman's monthly
          cycle.
        </p>
      </>
    ),
    maxClaims: 2,
    isTooltip: false,
    disable: true,
  },
  {
    title: "Gastroesophageal Reflux Disease (GERD)",
    code: "gastroesophagealRefluxDiseaseGerd",
    content: (
      <p>
        Gastroesophageal reflux disease (GERD) occurs when gastric acid refluxes
        into the esophagus, causing symptoms such as heartburn and
        regurgitation.
      </p>
    ),
    isTooltip: false,
    disable: true,
  },
  {
    title: "Hemorrhoids",
    code: "hemorrhoids",
    content: (
      <p>
        Hemorrhoids (also called “Piles”) are a swelling of the veins or blood
        vessels in and around the anus and lower rectum. Hemorrhoids can be
        internal, external or both.
      </p>
    ),
    maxClaims: 3,
    isTooltip: false,
    disable: true,
  },
  {
    title: "Herpes labialis (Cold sores)",
    code: "herpesLabialisColdSores",
    content: (
      <p>
        Herpes labialis is a rash of the skin and mucous membranes (in
        particular, the lips) and is characterized by erythema and blisters that
        are preceded and accompanied by burning pain.
      </p>
    ),
    upcomingFollowUp: (
      <div className="mt-2 mb-2 p-3 mx-2.5 flex bg-blue-100 border-[1px] border-blue-400 rounded-[4px]">
        <div className="w-12 min-w-[48px] h-12">
          <img
            src="/icons/info-circle.svg"
            alt="info-circle"
            className="w-12 h-12"
          />
        </div>
        <div className="flex flex-col ml-5 mt-3 ">
          <p className="text-body-md font-semibold text-gray-800">
            Past Due: Follow Up Was Due January 5th.
          </p>
          <p className="text-body-md mt-2 text-gray-800 font-normal">
            Minor Ailment service was completed on September 30, 2023. Complete
            a follow up prior to initiating a new minor ailment service.
          </p>
        </div>
        <Button
          type={"primary-outline"}
          text="Start Follow Up"
          className="ml-[50px] !max-w-[200px] w-full h-max my-auto"
        />
      </div>
    ),
    isTooltip: false,
    disable: true,
  },
  {
    title: "Impetigo",
    code: "impetigo",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Insect bites and urticaria (Hives)",
    code: "insectBitesAndUrticariaHives",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Tick bites, post-exposure prophylaxis to prevent Lyme disease",
    code: "tickBitesPostExposureProphylaxisToPreventLymeDisease",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Musculoskeletal sprains and strains",
    code: "musculoskeletalSprainsAndStrains",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Nausea and vomiting of pregnancy",
    code: "nauseaAndVomitingOfPregnancy",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Pinworms and threadworms",
    code: "pinwormsAndThreadworms",
    content: " ",
    isTooltip: false,
    disable: true,
  },
  {
    title: "Urinary Tract Infections (Uncomplicated)",
    code: "urinaryTractInfectionsUncomplicated",
    content: <UrinaryTractData />,
    maxClaims: 3,
    isTooltip: false,
    disable: false,
  },
  {
    title: "Vulvovaginal candidiasis (Yeast infection)",
    code: "vulvovaginalCandidiasisYeastInfection",
    content: " ",
    isTooltip: false,
    disable: true,
  },
];

export const ailmentServices = [
  {
    label:
      "I received informed consent from the Patient, or Alternate Caregiver for the Minor Ailment Service.",
  },
  {
    label:
      "I informed the Patient, or Alternate Caregiver that if a prescription is provided, it may be filled at a pharmacy of their choice.",
  },
  {
    label:
      "I informed the Patient, or Alternate Caregiver that the assessment details, and results including the prescription will be shared with the Primary Provider within a reasonable time.",
  },
  {
    label:
      "I informed the Patient, or Alternate Caregiver that any information obtained from the service will only be shared within the circle of care of the Patient (this includes the pharmacy team or other health care professionals directly involved with the care of the patient).",
  },
  {
    label:
      "I informed the Patient, or Alternate Caregiver you should always consult your Primary Provider for any medical matters, and never delay seeking medical advice, do not ignore medical advice or discontinue medical treatment because of the information contained herein with using REEL for this Clinical Service.",
  },
];

export const medicationReviewSteps = [
  {
    name: "Pre-Assessment",
    subSteps: [
      { name: "Consent Form", show: true },
      { name: "Pregnancy", show: true },
    ],
  },
  {
    name: "Clinical Assessment",
    subSteps: [
      { name: "Allergies", show: true },
      { name: "Medical History", show: true },
      { name: "Adherence", show: true },
    ],
  },
  {
    name: "Health & Wellness",
    subSteps: [
      { name: "Lifestyle", show: true },
      { name: "Vaccines", show: true },
    ],
  },
  {
    name: "Medications",
    subSteps: [
      { name: "Goals of Medication Review", show: true },
      { name: "Medication Review", show: true },
      { name: "Additional Medication", show: true },
    ],
  },
  {
    name: "Education",
    subSteps: [
      { name: "Education - Review Prescriptions", show: true },
      { name: "Follow Up - Appointments", show: true },
    ],
  },
  {
    name: "Documentation",
    subSteps: [
      { name: "Referrals & Notifications", show: true },
      { name: "Documentation - Sources / Checklist", show: true },
      { name: "Documentation - Forms", show: true },
    ],
  },
];

export const minorAilmentSteps = [
  {
    name: "Pre-Assessment",
    subSteps: [
      { name: "Consent Form", show: true },
      { name: "Pregnancy", show: true },
    ],
  },
  {
    name: "Clinical Assessment",
    subSteps: [
      { name: "Allergies", show: true },
      { name: "Lifestyle", show: false },
      { name: "Red Flag", show: true },
      { name: "Drug Induced", show: true },
    ],
  },
  {
    name: "Signs & Symptoms",
    subSteps: [
      { name: "Non-Typical", show: true },
      { name: "Typical", show: true },
      { name: "Infective", show: true },
    ],
  },
  {
    name: "Differential Assessment",
    subSteps: [{ name: "Differential Assessment", show: true }],
  },
  {
    name: "Treatment",
    subSteps: [
      { name: "Classification of Allergic Rhinitis", show: true },
      { name: "Allergic Rhinitis Results", show: true },
      { name: "Goals of Therapy", show: true },
      { name: "Treatment History", show: true },
      { name: "Non-Pharmacological", show: true },
      { name: "Pharmacological", show: true },
    ],
  },
  {
    name: "Education",
    subSteps: [
      { name: "Prevention Tips", show: true },
      { name: "Education - Review Prescriptions", show: true },
      { name: "Follow Up - Appointments", show: true },
    ],
  },
  {
    name: "Documentation",
    subSteps: [
      { name: "Referrals & Notifications", show: true },
      { name: "Documentation Forms - Allergic Rhinitis", show: true },
    ],
  },
];

export const getSteps = (serviceSteps, step, subStep, direction = 1) => {
  let nextStep = step;
  let nextSubStep = subStep;
  if (direction === 1) {
    if (step <= serviceSteps.length) {
      const totalSubStep = serviceSteps[step - 1].subSteps.length;
      if (subStep === totalSubStep) {
        nextStep++;
        nextSubStep = 1;
      } else {
        nextSubStep++;
      }
    }
  } else {
    if (subStep === 1 && step > 1) {
      nextStep--;
      const totalSubStep = serviceSteps[nextStep - 1].subSteps.length;
      nextSubStep = totalSubStep;
    } else if (subStep > 1) {
      nextSubStep--;
    }
  }
  return { step: nextStep, subStep: nextSubStep };
};

export const isSubStepVisible = (serviceSteps, step, subStep) => {
  const stepObj = serviceSteps[step - 1]; // Get the step object based on the index
  const subStepObj = stepObj?.subSteps[subStep - 1]; // Get the substep object based on the index
  // Check if subStep exists and if its 'show' property is true
  return subStepObj?.show === true;
};

export const getValidStep = (
  serviceSteps,
  currentStep,
  currentSubStep,
  direction
) => {
  let nextStep = currentStep;
  let nextSubStep = currentSubStep;
  do {
    const { step, subStep } = getSteps(
      serviceSteps,
      nextStep,
      nextSubStep,
      direction
    );
    nextStep = step;
    nextSubStep = subStep;
  } while (!isSubStepVisible(serviceSteps, nextStep, nextSubStep));
  return { nextStep: nextStep, nextSubStep: nextSubStep };
};

//used to ignore all the steps inbetween during End Service
export const updateStepsValidity = (
  serviceSteps,
  currentStep,
  currentSubStep,
  disable
) => {
  return serviceSteps.map((step, i) => ({
    ...step,
    //disable all the substeps that we are skipping, from next step till documentation step.
    subSteps: step.subSteps.map((subStep, subIndex) => {
      if (i + 1 === currentStep && subIndex + 1 > currentSubStep) {
        return { ...subStep, show: !disable };
      } else if (
        i + 1 > currentStep &&
        i + 1 < MinorAilmentStep.Documentation
      ) {
        return { ...subStep, show: !disable };
      } else return subStep;
    }),
  }));
};

export const medReviewChecks = [
  {
    label: "To learn more about my prescription medications",
  },
  {
    label:
      "To learn more about non-prescription medications, vitamins, or natural health products",
  },
  {
    label: "To learn more about how to manage my chronic conditions",
  },
  {
    label: "To learn how to manage side effects",
  },
  {
    label: "To learn if my medication is working for me.",
  },
  {
    label:
      "To learn the importance of medications that need routine laboratory monitoring.",
  },
  {
    label: "Initiate compliance packaging",
  },
  {
    label: "I had a recent discharge from hospital.",
  },
  {
    label: "I have a planned upcoming hospital admission.",
  },
];

export const medicationReviewTypes = [
  {
    title: "Annual Medication Review",
    content: (
      <p>
        Taking at least 3 prescription medications for chronic medical
        condition. Can be performed once annually.
      </p>
    ),
    hiddenContent: (
      <p>
        <b>
          The Criteria of Three Prescription Medications For a Chronic Condition
          <br />
        </b>
        <br />
        A prescription medication is defined as a Schedule 1 drug according to
        the National Association of <br />
        Pharmacy Regulatory Authorities, National Drug Schedules. In addition,
        it may be a substance listed in the
        <br />
        Prescription Drug List to the Food and Drugs Act or in the Schedules to
        the Controlled Drugs and Substances <br />
        Act (Canada).
        <br />
        <br />
        The number of medications is based on the number of drug identification
        numbers(DIN). For example, a <br />
        single tablet that is a combination of two or more active medication
        ingredients will have one DIN and will <br />
        be considered one drug under the MedsCheck Program.
        <br />
        <br />
        Two different strengths of the same medication count as one medication,
        even if they have different DINs.
      </p>
    ),
    maxClaims: 1,
    isClaimTooltip: true,
    allowReview: true,
    disable: false,
  },
  {
    title: "Follow Up Medication Review - Hospital Discharge (within 2 weeks)",
    content: (
      <p>
        The medication review (MedsCheck) follow-up is conducted within two
        weeks after a patient is discharged from hospital
      </p>
    ),
    hiddenContent: (
      <p>
        <b>
          The Criteria of Three Prescription Medications For a Chronic Condition
          <br />
        </b>
        <br />
        A prescription medication is defined as a Schedule 1 drug according to
        the National Association of <br />
        Pharmacy Regulatory Authorities, National Drug Schedules. In addition,
        it may be a substance listed in the
        <br />
        Prescription Drug List to the Food and Drugs Act or in the Schedules to
        the Controlled Drugs and Substances <br />
        Act (Canada).
        <br />
        <br />
        The number of medications is based on the number of drug identification
        numbers(DIN). For example, a <br />
        single tablet that is a combination of two or more active medication
        ingredients will have one DIN and will <br />
        be considered one drug under the MedsCheck Program.
        <br />
        <br />
        Two different strengths of the same medication count as one medication,
        even if they have different DINs.
      </p>
    ),
    maxClaims: 1,
    isTooltip: true,
    allowReview: true,
    disable: true,
  },
  {
    title: "Follow Up Medication Review - Pharmacist Decision",
    content: (
      <p>
        A Medication Review (MedsCheck) Follow-up may be conducted at the
        discretion of the pharmacist under specific documented circumstances.
      </p>
    ),
    hiddenContent: (
      <p>
        <b>
          The Criteria of Three Prescription Medications For a Chronic Condition
          <br />
        </b>
        <br />
        A prescription medication is defined as a Schedule 1 drug according to
        the National Association of <br />
        Pharmacy Regulatory Authorities, National Drug Schedules. In addition,
        it may be a substance listed in the
        <br />
        Prescription Drug List to the Food and Drugs Act or in the Schedules to
        the Controlled Drugs and Substances <br />
        Act (Canada).
        <br />
        <br />
        The number of medications is based on the number of drug identification
        numbers(DIN). For example, a <br />
        single tablet that is a combination of two or more active medication
        ingredients will have one DIN and will <br />
        be considered one drug under the MedsCheck Program.
        <br />
        <br />
        Two different strengths of the same medication count as one medication,
        even if they have different DINs.
      </p>
    ),
    maxClaims: 1,
    isTooltip: true,
    allowReview: true,
    disable: true,
  },
  {
    title: "Follow up Medication Review - Planned Hospital Admission",
    content: (
      <p>
        Patients scheduled for a hospital admission, may qualify and benefit
        from a Medication review.
      </p>
    ),
    hiddenContent: (
      <p>
        <b>
          The Criteria of Three Prescription Medications For a Chronic Condition
          <br />
        </b>
        <br />
        A prescription medication is defined as a Schedule 1 drug according to
        the National Association of <br />
        Pharmacy Regulatory Authorities, National Drug Schedules. In addition,
        it may be a substance listed in the
        <br />
        Prescription Drug List to the Food and Drugs Act or in the Schedules to
        the Controlled Drugs and Substances <br />
        Act (Canada).
        <br />
        <br />
        The number of medications is based on the number of drug identification
        numbers(DIN). For example, a <br />
        single tablet that is a combination of two or more active medication
        ingredients will have one DIN and will <br />
        be considered one drug under the MedsCheck Program.
        <br />
        <br />
        Two different strengths of the same medication count as one medication,
        even if they have different DINs.
      </p>
    ),
    maxClaims: 1,
    isTooltip: true,
    allowReview: true,
    disable: true,
  },

  {
    title: "Follow Up Medication Review - Physician ",
    content: (
      <p>
        A family physician, a specialist or a registered nurse in the extended
        class [RN(EC)]/nurse practitioner (NP) may refer a patient for a
        Medication Review (MedsCheck).
      </p>
    ),
    hiddenContent: (
      <p>
        <b>
          The Criteria of Three Prescription Medications For a Chronic Condition
          <br />
        </b>
        <br />
        A prescription medication is defined as a Schedule 1 drug according to
        the National Association of <br />
        Pharmacy Regulatory Authorities, National Drug Schedules. In addition,
        it may be a substance listed in the
        <br />
        Prescription Drug List to the Food and Drugs Act or in the Schedules to
        the Controlled Drugs and Substances <br />
        Act (Canada).
        <br />
        <br />
        The number of medications is based on the number of drug identification
        numbers(DIN). For example, a <br />
        single tablet that is a combination of two or more active medication
        ingredients will have one DIN and will <br />
        be considered one drug under the MedsCheck Program.
        <br />
        <br />
        Two different strengths of the same medication count as one medication,
        even if they have different DINs.
      </p>
    ),
    maxClaims: 1,
    isTooltip: true,
    allowReview: true,
    disable: true,
  },

  {
    title: "Follow Up Medication Review - Nurse Practitioner Referral",
    content: (
      <p>
        A family physician, a specialist or a registered nurse in the extended
        class [RN(EC)]/nurse practitioner (NP) may refer a patient for a
        Medication Review (MedsCheck).
      </p>
    ),
    hiddenContent: (
      <p>
        <b>
          The Criteria of Three Prescription Medications For a Chronic Condition
          <br />
        </b>
        <br />
        A prescription medication is defined as a Schedule 1 drug according to
        the National Association of <br />
        Pharmacy Regulatory Authorities, National Drug Schedules. In addition,
        it may be a substance listed in the
        <br />
        Prescription Drug List to the Food and Drugs Act or in the Schedules to
        the Controlled Drugs and Substances <br />
        Act (Canada).
        <br />
        <br />
        The number of medications is based on the number of drug identification
        numbers(DIN). For example, a <br />
        single tablet that is a combination of two or more active medication
        ingredients will have one DIN and will <br />
        be considered one drug under the MedsCheck Program.
        <br />
        <br />
        Two different strengths of the same medication count as one medication,
        even if they have different DINs.
      </p>
    ),
    maxClaims: 1,
    isTooltip: true,
    allowReview: true,
    disable: true,
  },
];

export const claimInfo = [
  {
    Date: "Jun 25, 2023*",
    RxDetails: "Rx Issued in person",
    ReviewType: "Annual Medication Review",
    PIN: "0000000",
    Location: "Rexall - 234 Dufferin St. Toronto",
  },
  {
    Date: "Feb 07, 2021",
    RxDetails: "No Rx Issued in person",
    ReviewType: "Annual Medication Review",
    PIN: "0000000",
    Location: "Rexall - 234 Dufferin St. Toronto",
  },
  {
    Date: "Aug 15, 2020",
    RxDetails: "Rx Issued in virtual",
    ReviewType: "Annual Medication Review",
    PIN: "0000000",
    Location: "Rexall - 234 Dufferin St. Toronto",
  },
  {
    Date: "Apr 2, 2029",
    RxDetails: "No Rx Issued in virtual",
    ReviewType: "Annual Medication Review",
    PIN: "0000000",
    Location: "Rexall - 234 Dufferin St. Toronto",
  },
];

export const medReviewConsentChecks = [
  {
    label:
      "I received informed consent from the patient, or alternate caregiver for the Annual Medication Review.",
  },
  {
    label:
      "A medication review (MedsCheck) includes a completed Personal Medication Record that is signed and dated by the pharmacist.",
  },
  {
    label:
      "The completed Medication Review (MedsCheck) aims to resolve real or potential drug therapy related problems identified by you , the pharmacist or your primary care provider.",
  },
  {
    label:
      "The accuracy of the information on the final Medication Review (MedsCheck) document depends on the accuracy and completeness of the information provided by the patient at the time the MedsCheck was performed.",
  },
  {
    label:
      "I informed the Patient, or Alternate Caregiver that any information obtained from the service will only be shared within the circle of care of the Patient (this includes the pharmacy team or other health care professionals directly involved with the care of the patient).",
  },
  {
    label:
      "I informed the Patient, or Alternate Caregiver you should always consult your Primary Provider for any medical matters, and never delay seeking medical advice, do not ignore medical advice or discontinue medical treatment because of the information contained herein with using REEL for this Clinical Service.",
  },
];

// Default intervention steps - centralized definition
// Canonical names for intervention steps
export const InterventionStepsEnum = {
  InterventionDetails: "Intervention Details",
  TargetsResults: "Targets & Results",
  PharmacistFollowUp: "Pharmacist Follow Up",
  PrescriberFollowUp: "Prescriber Follow Up",
  Notification: "Notification",
  Documentation: "Documentation",
  Billing: "Billing",
};

export const defaultInterventionSteps = [
  { stepNumber: 1, name: InterventionStepsEnum.InterventionDetails, label: "Intervention Details", disabled: false, comingSoon: false, disabledTooltip: false, disabledTooltipMessage: "" },
  { stepNumber: 2, name: InterventionStepsEnum.TargetsResults, label: "Targets & Results", disabled: false, comingSoon: true, disabledTooltip: false, disabledTooltipMessage: "" },
  { stepNumber: 3, name: InterventionStepsEnum.PharmacistFollowUp, label: "Pharmacist Follow Up", disabled: false, comingSoon: false, disabledTooltip: false, disabledTooltipMessage: "" },
  { stepNumber: 4, name: InterventionStepsEnum.PrescriberFollowUp, label: "Prescriber Follow Up", disabled: false, comingSoon: false, disabledTooltip: false, disabledTooltipMessage: "" },
  { stepNumber: 5, name: InterventionStepsEnum.Notification, label: "Notification", disabled: false, comingSoon: false, disabledTooltip: false, disabledTooltipMessage: "" },
  { stepNumber: 6, name: InterventionStepsEnum.Documentation, label: "Documentation", disabled: false, comingSoon: false, disabledTooltip: true, disabledTooltipComponent: (
    <div className="bg-white p-2 text-sm text-gray-700 rounded shadow-lg">
      <p>Must complete the intervention in order to <br/>view Documentation and Billing.</p>
    </div>
  ) },
  { stepNumber: 7, name: InterventionStepsEnum.Billing, label: "Billing", disabled: false, comingSoon: false, disabledTooltip: true, disabledTooltipComponent: (
    <div className="bg-white p-2 text-sm text-gray-700 rounded shadow-lg">
      <p>Must complete the intervention in order to <br/>view Documentation and Billing.</p>
    </div>
  ) }
];

// Bidirectional navigation function for intervention steps
// Based on getValidStep logic from data.jsx
export const findAvailableStep = (currentStep, interventionSteps, direction = 1) => {
  if (!interventionSteps || interventionSteps.length === 0) {
    return currentStep;
  }
  
  let nextStep = currentStep;
  const maxSteps = interventionSteps.length;
  
  if (direction === 1) {
    // Moving forward
    do {
      nextStep++;
      // Check if we've gone beyond available steps
      if (nextStep > maxSteps) {
        return currentStep; // Stay on current step if no next available
      }
      
      const stepIndex = nextStep - 1;
      const step = interventionSteps[stepIndex];
      
      // Check if step is available (not disabled and not coming soon)
      if (step && !step.disabled && !step.comingSoon) {
        return nextStep;
      }
    } while (nextStep <= maxSteps);
  } else {
    // Moving backward
    do {
      nextStep--;
      // Check if we've gone below available steps
      if (nextStep < 1) {
        return currentStep; // Stay on current step if no previous available
      }
      
      const stepIndex = nextStep - 1;
      const step = interventionSteps[stepIndex];
      
      // Check if step is available (not disabled and not coming soon)
      if (step && !step.disabled && !step.comingSoon) {
        return nextStep;
      }
    } while (nextStep >= 1);
  }
  
  // If no step found, return current step
  return currentStep;
};